import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { UPDATE, crudGetOne } from 'react-admin';
import { connect } from 'react-redux';
import dataProvider from '../dataProvider';
import temporaryPassword from '../lib/temporaryPassword';

const style = {
  label: {
    fontFamily: 'monospace',
    fontSize: '24px',
    margin: '8px 0',
  },
  error: {
    color: '#f44336',
  },
};

// sets a temporary password for a child, such as the one printed on the label in their first kit, then
// shows their username and the password together for the label. platform marks the password as
// temporary until it next changes
class TemporaryPasswordDialog extends Component {
  state = {
    password: temporaryPassword(),
    isSaving: false,
    saved: false,
    errors: [],
  };

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  };

  handleSuggestClick = () => {
    this.setState({ password: temporaryPassword(), errors: [] });
  };

  handleSaveClick = () => {
    const { record } = this.props;
    const password = this.state.password.trim();

    this.setState({ password, isSaving: true, errors: [] });
    dataProvider(UPDATE, 'users', {
      id: record.id,
      data: {
        password,
        issue_temporary_password: true,
        _comment: 'Set a temporary password',
      },
    })
      .then(() => this.setState({ isSaving: false, saved: true }))
      .catch((error) => {
        const errors = error.message && error.message.errors;
        this.setState({
          isSaving: false,
          errors: errors ? errors.map(e => e.detail) : ["The password couldn't be saved"],
        });
      });
  };

  handleCloseClick = () => {
    const { close, crudGetOne, record } = this.props;
    const { saved } = this.state;

    // fetch the child again, so their page shows the temporary password
    if (saved) {
      crudGetOne('users', record.id, '/users');
    }
    close();
  };

  render() {
    const { classes, record } = this.props;
    const { password, isSaving, saved, errors } = this.state;

    return (
      <Dialog
        aria-label="Set Temporary Password"
        fullWidth
        open
        onClick={event => event.stopPropagation()}
        onClose={isSaving ? undefined : this.handleCloseClick}
      >
        <DialogTitle>
          Set Temporary Password
        </DialogTitle>
        {saved && (
          <DialogContent>
            <DialogContentText>
              {`Print these on the label for ${record.name}'s kit. The password isn't shown again.`}
            </DialogContentText>
            <Typography
              className={classes.label}
            >
              {`Username: ${record.username}`}
            </Typography>
            <Typography
              className={classes.label}
            >
              {`Password: ${password}`}
            </Typography>
          </DialogContent>
        ) || (
          <DialogContent>
            <DialogContentText>
              {`${record.name} signs in with this password until it's changed. Their current password stops working.`}
            </DialogContentText>
            <TextField
              disabled={isSaving}
              label="Password"
              margin="normal"
              value={password}
              fullWidth
              onChange={this.handlePasswordChange}
            />
            {errors.map((error, i) => (
              <Typography
                className={classes.error}
                component="p"
                key={`error-${i}`}
              >
                {error}
              </Typography>
            ))}
          </DialogContent>
        )}
        <DialogActions>
          {saved && (
            <Button
              color="primary"
              onClick={this.handleCloseClick}
            >
              Done
            </Button>
          ) || (
            <>
              <Button
                disabled={isSaving}
                onClick={this.handleSuggestClick}
              >
                Suggest Another
              </Button>
              <Button
                disabled={isSaving}
                onClick={this.handleCloseClick}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                disabled={isSaving || !password.trim()}
                onClick={this.handleSaveClick}
              >
                Save
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    );
  }
}

TemporaryPasswordDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  crudGetOne: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  crudGetOne,
};

export default withStyles(style)(connect(null, mapDispatchToProps)(TemporaryPasswordDialog));
